var map = {
	"./Jean_Mielot.avif": 80984,
	"./Jean_Mielot.png": 41349,
	"./Olivetti.avif": 4138,
	"./Olivetti.png": 72592,
	"./Ragazzo.avif": 69993,
	"./Ragazzo.png": 17191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2712;